export { EloShareTemplateIcon } from './share-template-icon'
